import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE_URL = (import.meta.env.VITE_API_URL || "").replace(/\/$/, "");

export default function Login() {
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        if (!API_BASE_URL) {
            setError("Mungon VITE_API_URL.");
            setLoading(false);
            return;
        }

        try {
            const loginUrl = `${API_BASE_URL}/auth/login`;
            console.log("LOGIN URL:", loginUrl);

            const response = await axios.post(
                loginUrl,
                {
                    username: username.trim(),
                    password,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("LOGIN OK:", response.data);

            localStorage.setItem("access_token", response.data.access_token);
            localStorage.setItem("refresh_token", response.data.refresh_token);
            localStorage.setItem("username", response.data.username);
            localStorage.setItem("role", response.data.role);

            navigate("/dashboard");
        } catch (err) {
            console.log("LOGIN ERROR STATUS:", err.response?.status);
            console.log("LOGIN ERROR DATA:", err.response?.data);
            console.log("LOGIN ERROR MESSAGE:", err.message);

            const message =
                err.response?.data?.error ||
                err.message ||
                "Gabim gjatë hyrjes. Provo përsëri.";

            setError(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                maxWidth: "420px",
                margin: "60px auto",
                background: "#fff",
                padding: "30px",
                borderRadius: "16px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            }}
        >
            <h2 style={{ marginBottom: "20px", textAlign: "center" }}>
                Hyrje Admin
            </h2>

            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", marginBottom: "6px" }}>
                        Emri i përdoruesit
                    </label>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Shkruaj username"
                        required
                        style={{
                            width: "100%",
                            padding: "10px 12px",
                            borderRadius: "10px",
                            border: "1px solid #ccc",
                            fontSize: "15px",
                            boxSizing: "border-box",
                        }}
                    />
                </div>

                <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", marginBottom: "6px" }}>
                        Fjalëkalimi
                    </label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Shkruaj fjalëkalimin"
                        required
                        style={{
                            width: "100%",
                            padding: "10px 12px",
                            borderRadius: "10px",
                            border: "1px solid #ccc",
                            fontSize: "15px",
                            boxSizing: "border-box",
                        }}
                    />
                </div>

                {error && (
                    <div
                        style={{
                            marginBottom: "15px",
                            color: "#b00020",
                            background: "#ffe8ec",
                            padding: "10px",
                            borderRadius: "10px",
                            fontSize: "14px",
                        }}
                    >
                        {error}
                    </div>
                )}

                <button
                    type="submit"
                    disabled={loading}
                    style={{
                        width: "100%",
                        padding: "12px",
                        border: "none",
                        borderRadius: "10px",
                        background: "#111827",
                        color: "#fff",
                        fontSize: "15px",
                        cursor: "pointer",
                    }}
                >
                    {loading ? "Duke hyrë..." : "Hyr"}
                </button>
            </form>
        </div>
    );
}
